export class Occupation {
    constructor(public data?: {
        ID?: Number,
        Name?: String,
        HazardLevel?: Number
    }) { }
}